import { styled } from "@mui/material";

const List = styled("ul")({});

export type ListProps = typeof List extends (props: infer P) => any ? P : never;

export default List;
